import React, { PureComponent } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';

import loadable from '@loadable/component';
const ProductCard = loadable(() => import(`common/blocks/product/card`));

import { Row, Column } from '../../../styleguide/grid';
import { withCssUnit } from '../../../styleguide/utils';

import { getPageDataSelector } from '../../../../selectors/page';
import { capfl } from '../../../../utils/index';

import { fireGTMEvent } from 'common/utils/gtm';
import { PRODUCT_CLICK } from 'common/constants/GTMConstants';

const S = {};
S.Wrapper = styled.section`
  margin-bottom: 20px;
  @media (min-width: ${({ theme }) => withCssUnit(theme.breakpoints.md)}) {
    margin-bottom: 40px;
  }
  @media (min-width: ${({ theme }) => withCssUnit(theme.breakpoints.lg)}) {
    margin-bottom: 60px;
  }
`;

S.Row = styled(Row)`
  margin-left: -5px;
  margin-right: -5px;
  @media (min-width: ${({ theme }) => withCssUnit(theme.breakpoints.md)}) {
    margin-left: -10px;
    margin-right: -10px;
  }
`;

S.Column = styled(Column)`
  padding-left: 5px;
  padding-right: 5px;
  @media (min-width: ${({ theme }) => withCssUnit(theme.breakpoints.md)}) {
    padding-left: 10px;
    padding-right: 10px;
  }
`;

S.ProductCard = styled(ProductCard)`
  && {
    margin-bottom: 20px;
  }
`;

S.Header = styled.h4`
  margin-bottom: 35px;
  text-align: center;
  background: rgba(0, 0, 0, 0.05);
  padding: 15px 10px;
`;

S.Hr = styled.hr`
  border-bottom-color: #eeeeee;
  margin: 1em 0;
`;

const TotalMatch = ({ products, t }) => {
  return (
    <div>
      <S.Row>
        {_.map(products, (product, i) => {
          return (
            <S.Column
              size={{ xs: 6, sm: 6, md: 4, lg: 3, xl: 2 }}
              key={'total-match-products-listing-column-' + i}
            >
              <S.ProductCard
                data={product}
                showTitleOnTop={false}
                showBrandOnTop={false}
                showBrand={false}
                showLabels={true}
                lazyload={false}
              />
            </S.Column>
          );
        })}
      </S.Row>
      <S.Hr />
    </div>
  );
};

class Listing extends PureComponent {
  onProductCardClick = (product, GTMCategoryList) => e => {
    fireGTMEvent(PRODUCT_CLICK, [product], GTMCategoryList);
  };
  render() {
    const { products, totalMatch, t, GTMCategoryList = null } = this.props;
    if (!_.isEmpty(products) || !_.isEmpty(totalMatch)) {
      return (
        <S.Wrapper>
          {!_.isEmpty(totalMatch) ? (
            <TotalMatch products={totalMatch} t={t} />
          ) : (
            ''
          )}
          {!_.isEmpty(totalMatch) && !_.isEmpty(products) ? (
            <Row>
              <Column size={{ xs: 12 }}>
                <S.Header>
                  {capfl(t('you may be interested in'))}
                </S.Header>
              </Column>
            </Row>
          ) : (
            ''
          )}
          <S.Row>
            {_.map(products, (product, i) => {
              const productId = _.get(product, 'id', i);
              return (
                <S.Column
                  size={{ xs: 6, sm: 6, md: 4, lg: 3, xl: 2 }}
                  key={'products-listing-column-' + productId}
                >
                  <S.ProductCard
                    data={product}
                    showTitleOnTop={false}
                    showBrandOnTop={false}
                    showBrand={false}
                    showLabels={true}
                    imageWidth={215}
                    imageHeight={225}
                    lazyload={false}
                    onClick={this.onProductCardClick(product, GTMCategoryList)}
                  />
                </S.Column>
              );
            })}
          </S.Row>
        </S.Wrapper>
      );
    }
    return null;
  }
}

const makeMapStateToProps = () => {
  const getPageData = getPageDataSelector();
  return (state, props) => {
    const { searchValue } = props;
    const pageData = getPageData(state, props);
    const propsToReturn = {};
    let products = [];
    if (pageData.products) {
      if (!_.isEmpty(searchValue)) {
        propsToReturn.totalMatch = _.filter(
          pageData.products,
          ({ ean, sku, partNo }) => {
            let value = _.toLower(searchValue);
            return (
              _.toLower(ean ? ean : '') === value ||
              _.toLower(sku ? sku : '') === value ||
              _.toLower(partNo ? partNo : '') === value
            );
          }
        );
        products = _.differenceBy(
          pageData.products,
          propsToReturn.totalMatch,
          'id'
        );
      } else {
        products = pageData.products;
      }
      propsToReturn.products = products;
    }
    return propsToReturn;
  };
};

const ListingConnected = connect(makeMapStateToProps)(Listing);

export default withTranslation('translations', { withRef: true })(
  ListingConnected
);
